import { EMPTY_LIST } from '../../constants/common'

import {
  WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
  WYSIWYG_EDITOR_INSET_AUTO,
  WYSIWYG_EDITOR_POSITION_STICKY,
} from './WysiwygEditor.constants'

function isStickyElement(element) {
  return getComputedStyle(element).position === WYSIWYG_EDITOR_POSITION_STICKY
}

function isStickyElementPinnedToTop(element) {
  return getComputedStyle(element).top !== WYSIWYG_EDITOR_INSET_AUTO
}

function isStickyElementPinnedToBottom(element) {
  return getComputedStyle(element).bottom !== WYSIWYG_EDITOR_INSET_AUTO
}

function getEditorPointStickyElements({ editor, x, y }) {
  const elements = document.elementsFromPoint(x, y)

  return elements.includes(editor.iframeElement)
    ? elements
        .slice(0, elements.indexOf(editor.iframeElement))
        .filter(isStickyElement)
    : EMPTY_LIST
}

function getEditorTopStickyEdge({ editor, x, y }) {
  const [stickyElement] = getEditorPointStickyElements({ editor, x, y }).filter(
    isStickyElementPinnedToTop
  )

  return stickyElement
    ? getEditorTopStickyEdge({
        editor,
        x,
        y:
          stickyElement.getBoundingClientRect().bottom +
          WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
      })
    : y
}

function getEditorBottomStickyEdge({ editor, x, y }) {
  const [stickyElement] = getEditorPointStickyElements({ editor, x, y }).filter(
    isStickyElementPinnedToBottom
  )

  return stickyElement
    ? getEditorBottomStickyEdge({
        editor,
        x,
        y:
          stickyElement.getBoundingClientRect().top -
          WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
      })
    : y
}

function getEditorRectTopStickyOverlap({ editor, rect, stickyView }) {
  const top = rect.top + WYSIWYG_EDITOR_CARET_HIT_TEST_INSET
  const y = Math.max(top, stickyView.top + WYSIWYG_EDITOR_CARET_HIT_TEST_INSET)

  const edge = getEditorTopStickyEdge({
    editor,
    x: rect.left + WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
    y,
  })

  return edge > y ? edge - top : 0
}

function getEditorRectBottomStickyOverlap({ editor, rect, stickyView }) {
  const bottom = rect.bottom - WYSIWYG_EDITOR_CARET_HIT_TEST_INSET
  const y = Math.min(
    bottom,
    stickyView.bottom - WYSIWYG_EDITOR_CARET_HIT_TEST_INSET
  )

  const edge = getEditorBottomStickyEdge({
    editor,
    x: rect.left + WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
    y,
  })

  return edge < y ? bottom - edge : 0
}

export function getWysiwygEditorStickyScrollDelta({
  editor,
  rect,
  stickyView,
}) {
  return (
    getEditorRectBottomStickyOverlap({ editor, rect, stickyView }) -
    getEditorRectTopStickyOverlap({ editor, rect, stickyView })
  )
}
